module.exports = __webpack_public_path__ + "2f2c980c34afce7cad36dcbc30c6766a.svg";